import { Box, Stack, Button, styled } from '../../../../base';

export const StyledContainer = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
}));

export const StyledHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    gap: theme.spacing(1),
}));

export const StyledTopRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
}));

export const StyledContent = styled(Stack)(({ theme }) => ({
    paddingBlock: theme.spacing(0.5),
}));

export const StyledButton = styled(Button)(({ theme }) => ({
    color: theme.palette.grey[600],
    borderColor: theme.palette.grey[600],
    paddingInline: theme.spacing(4),
    paddingBlock: theme.spacing(0.5),
    borderRadius: theme.spacing(0.5),
    '&:hover': {
        borderColor: theme.palette.grey[600],
        backgroundColor: theme.palette.action.hover,
    },
}));
